import { Exception } from '@/redux/slices/slice_types';
import { useAppSelector } from '@/redux/hooks';
import { selectExceptionReferenceTypes, selectExceptionSubtypes, selectExceptionTypes } from '@/redux/selectors/constantsSelectors';

type ExceptionEnumMapProps = {
  enumRef: 'type' | 'subtype' | 'reference';
  value: Exception['type'] | Exception['subtype'];
};

const ExceptionEnumMap = ({ enumRef, value }: ExceptionEnumMapProps) => {
  const exceptionTypes = useAppSelector(selectExceptionTypes);
  const exceptionSubtypes = useAppSelector(selectExceptionSubtypes);
  const exceptionReferences = useAppSelector(selectExceptionReferenceTypes);

  const getRenderValue = () => {
    switch (enumRef) {
      case 'type':
        return exceptionTypes[value] || value;
      case 'subtype':
        return exceptionSubtypes[value] || value;
      case 'reference':
        return exceptionReferences[value] || value;
      default:
        return value;
    }
  };

  const renderValue = getRenderValue();

  return <>{renderValue}</>;
};

export default ExceptionEnumMap;
